var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerticalBar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 20.0008V16.8608C14.2 16.8276 14.1731 16.8008 14.14 16.8008H12.6H11.06C11.0269 16.8008 11 16.8276 11 16.8608V20.0008V23.2008V26.3408C11 26.3739 11.0269 26.4008 11.06 26.4008H12.6H14.14C14.1731 26.4008 14.2 26.3739 14.2 26.3408V23.2008V20.0008Z",
    stroke: "#CE375C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40007 16.2659V11.2592C7.40007 11.2261 7.37321 11.1992 7.34007 11.1992H5.80007H4.26007C4.22694 11.1992 4.20007 11.2261 4.20007 11.2592V16.2659V21.3326V26.3392C4.20007 26.3724 4.22694 26.3992 4.26007 26.3992H5.80007H7.34007C7.37321 26.3992 7.40007 26.3724 7.40007 26.3392V21.3326V16.2659Z",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.1996V12.6596C21 12.6265 20.9732 12.5996 20.94 12.5996H19.4H17.86C17.8269 12.5996 17.8 12.6265 17.8 12.6596V17.1996V21.7996V26.3396C17.8 26.3727 17.8269 26.3996 17.86 26.3996H19.4H20.94C20.9732 26.3996 21 26.3727 21 26.3396V21.7996V17.1996Z",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8 12.5329V5.65961C27.8 5.62647 27.7731 5.59961 27.74 5.59961H26.2H24.66C24.6268 5.59961 24.6 5.62647 24.6 5.65961V12.5329V19.4663V26.3396C24.6 26.3727 24.6268 26.3996 24.66 26.3996H26.2H27.74C27.7731 26.3996 27.8 26.3727 27.8 26.3396V19.4663V12.5329Z",
    stroke: "#CE375C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalBar2);
export default __webpack_public_path__ + "static/media/vertical-bar-2.118bc9ba7e250a38d8d9e5bbbd007df9.svg";
export { ForwardRef as ReactComponent };